import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { useToast } from "@/hooks/use-toast";

type Props = {
  value: string;
  children?: React.ReactNode;
  className?: string;
  transform?: (v: string) => string;
};

export function CopyOnClick({ value, children, className = "", transform }: Props) {
  const [copied, setCopied] = useState(false);
  const { toast } = useToast();

  async function handleCopy(e: React.MouseEvent) {
    e.stopPropagation();
    const finalValue = transform ? transform(value) : value;
    
    try {
      await navigator.clipboard.writeText(finalValue);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
      
      toast({
        title: "✓ Copiado",
        description: finalValue.length > 50 ? `${finalValue.slice(0, 50)}...` : finalValue,
        duration: 1200,
      });
    } catch {
      toast({
        title: "Erro ao copiar",
        variant: "destructive",
      });
    }
  }

  return (
    <button
      type="button"
      onClick={handleCopy}
      className={`inline-flex items-center gap-1.5 hover:bg-accent/50 rounded px-1 -mx-1 transition-colors group ${className}`}
      title="Clique para copiar"
    >
      <span className="select-none truncate">{children ?? value}</span>
      {copied ? (
        <Check className="h-3.5 w-3.5 text-success animate-in fade-in zoom-in duration-200" />
      ) : (
        <Copy className="h-3.5 w-3.5 opacity-0 group-hover:opacity-40 transition-opacity" />
      )}
    </button>
  );
}
